<template>
  <b-icon-info-circle-fill v-b-tooltip.hover.html="text" :font-scale="fontScale"/>
</template>

<script>
export default {
  name: "EsgInformation",
  props: ['text', 'fontScale'],
}
</script>

<style scoped>
.icon-box {
  width: 10px;
  height: 10px;
}

svg {
  cursor: pointer;
  user-select: none;
  user-focus: none;
}

:focus {
  outline: none !important;
}
</style>